import React from 'react';
import Pricing_Start from '../assests/Pricing_Start.jpg';
import Pricing_Mid from '../assests/Pricing_Mid.jpg';
import Pricing_Adv from '../assests/Pricing_Adv.jpg';

const HomePricePlan = () => {
  return (
    <section className="pricing-details">
        <div className="pricing-content">
          <div className="pricing-text">
            <h2>TRAINER PRICING CHART</h2>
            <h1>Exclusive Pricing Plan</h1>
            <p>Vortex gym membership offers flexible options. Choose the plan that fits your fitness goals and schedule.</p>
          </div>
        </div>
        <div>
          <div className="pricing-cards">
            <div className="pricing-card">
              <div className="card-image">
                <img src={Pricing_Start} alt="Plan 1" />
              </div>
              <div className="card-text">
                <h2>Beginner</h2>
                <br />
                <h3>₹ 8000</h3>
                <br />
                <h4>4 Months </h4>
                <br />
                <p>Core</p>
                <br />
                <p>Diet Chart</p>
                <br />
                <p>Muscle Gain</p>
                <br />
                <p>Machine Learning</p>
              </div>
            </div>
            <div className="pricing-card">
              <div className="card-image">
                <img src={Pricing_Mid} alt="Plan 2" />
              </div>
              <div className="card-text">
                <h2>Intermediate</h2>
                <br />
                <h3>₹ 10000</h3>
                <br />
                <h4>6 Months </h4>
                <br />
                <p>Core</p>
                <br />
                <p>Diet Chart</p>
                <br />
                <p>Weight Lifting</p>
                <br />
                <p>Strength and Agility</p>
              </div>
            </div>
            <div className="pricing-card">
              <div className="card-image">
                <img src={Pricing_Adv} alt="Plan 3" />
              </div>
              <div className="card-text">
                <h2>Advanced</h2>
                <br />
                <h3>₹ 18000</h3>
                <br />
                <h4>9 Months </h4>
                <br />
                <p>Core</p>
                <br />
                <p>Diet Chart</p>
                <br />
                <p>Power Lifting</p>
                <br />
                <p>Combat Training</p>
              </div>
            </div>
          </div>
        </div>
      </section>
  )
}

export default HomePricePlan;